<template>
	<div class="social-buttons">
		<div class="social-buttons__buttonRow" v-if="showGoogleButton">
			<TeamingButton @buttonPress="onGoogleClick" type="SECONDARY">
				<template v-slot:leftIcon>
					<GoogleIcon />&nbsp;
				</template>
				{{ googleButtonText }}
			</TeamingButton>
		</div>
		<div class="social-buttons__buttonRow" v-if="showMicrosoftButton">
			<TeamingButton @buttonPress="onMicrosoftClick" type="SECONDARY">
				<template v-slot:leftIcon>
					<MicrosoftIcon />&nbsp;
				</template>
				{{ microsoftButtonText }}
			</TeamingButton>
		</div>
		<div class="social-buttons__buttonRow" v-if="showEmailButton">
			<TeamingButton
				:left-icon="['fas', 'envelope']"
				@buttonPress="onEmailClick"
				type="SECONDARY"
			>
				{{ emailButtonText }}
			</TeamingButton>
		</div>
	</div>
</template>

<script>
import {
	TeamingButton,
	GoogleIcon,
	MicrosoftIcon
} from "@teaming/common-ui";

export default {
	name: "SocialButtons",
	components: {
		GoogleIcon,
		MicrosoftIcon,
		TeamingButton,
	},
	emits: [ "googleClick", "microsoftClick", "emailClick", ],
	props: {
		googleButtonText: {
			type: String,
			required: true,
		},
		microsoftButtonText: {
			type: String,
			required: true,
		},
		emailButtonText: {
			type: String,
			required: true,
		},
		showGoogleButton: {
			type: Boolean,
			default: true,
		},
		showMicrosoftButton: {
			type: Boolean,
			default: true,
		},
		showEmailButton: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		onGoogleClick() {
			this.$emit( "googleClick" );
		},
		onMicrosoftClick() {
			this.$emit( "microsoftClick" );
		},
		onEmailClick() {
			this.$emit( "emailClick" );
		},
	},
};
</script>

<style lang="scss" scoped>
.social-buttons__buttonRow {
	margin-bottom: 1.5rem;
}
</style>
